import {
  AfterViewInit, ChangeDetectionStrategy, Component, ContentChildren, HostBinding, OnInit,
  QueryList, ViewEncapsulation
} from '@angular/core';
import { Subject } from 'rxjs';

import { PanelComponent } from '../panel/panel.component';

@Component({
  selector: 'mcrai-panel-group',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-panel-group{display:block}.mcrai-panel-group>.mcrai-panel{margin-bottom:5px}.mcrai-panel-group>.mcrai-panel:last-child{margin-bottom:0}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mcrai-panel-group]': 'true'
  }
})
export class GroupComponent implements OnInit, AfterViewInit {
  @ContentChildren(PanelComponent) private _panels: QueryList<PanelComponent>;

  private _destroy: Subject<any> = new Subject();

  constructor() { }

  ngOnInit() { }

  ngAfterViewInit() {
    this._panels.forEach((panel, index) => {
      panel.header.clickEvent
        .takeUntil(this._destroy)
        .subscribe(() => this._onPanelClick(index));
    });
  }

  private _onPanelClick(index: number): void {
    this._panels.forEach((panel, i) => {
      if (index === i) {
        panel.open();
      } else {
        panel.close();
      }
    });
  }

}
